var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.quicks),function(quick,idx){return _c('ivc-cell-hierachy',_vm._b({key:idx,staticClass:"cell-multi-hierachy"},'ivc-cell-hierachy',{ ..._vm.$attrs, ..._vm.$props, quicks: quick, value: _vm.value },false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }